import React from 'react'
import {
  TextArea,
  Form,
  Button,
  Message,
  Icon,
  Modal,
  Select,
  Image,
  Confirm,
  Label,
  Grid,
  Dropdown,
  Checkbox
} from 'semantic-ui-react'
import ReactDOM from 'react-dom'
import Thumbnail from '../thumbnail/index'
import {createAPIClient, createAWSClient} from '../../../../../services/api'
import {createIssueAction} from '../../../../../actions/issues.action'
import {connect} from 'react-redux'
import CreatableSelect from 'react-select/creatable'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import RecurrencePicker from './RecurrencePicker'
import {defaultRecurrence} from '../../../../../utils/recurrence'

const {Field} = Form
const listStyle = {'padding': 0}
const listItemStyle = {display: 'block', marginBottom: '5px'}
const modalStyle = {marginTop: '0px !important', marginLeft: 'auto', marginRight: 'auto'}
const confirmStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}

class EditForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      openConfirm: false,
      enableFileUpload: false,
      imageUploading: false,
      editingError: undefined,
      editingErrorMessage: undefined,
      newIssue: {
        id: '',
        title: '',
        description: '',
        custom_field_values: {},
        attachments: []
      },
      repeatRule: {
        name: '',
        date: undefined,
        recurrence: defaultRecurrence()
      },
      isRepeatRule: false,
    }
  }
  showConfirm () {
    this.setState({openConfirm: true})
  }
  handleCancel () {
    this.setState({openConfirm: false})
  }
  switchRepeatRule (e, {checked}) {
    const repeatRule = checked
      ? Object.assign({}, this.state.repeatRule, {
        recurrence: this.state.repeatRule.recurrence || defaultRecurrence(this.state.repeatRule.date)
      })
      : this.state.repeatRule
    this.setState({isRepeatRule: checked, repeatRule})
  }
  setRepeatRuleName (e) {
    let title = e.target.value
    const repeatRule = Object.assign({}, this.state.repeatRule, {name: title})
    this.setState({repeatRule: repeatRule})
  }
  setRecurrence (recurrence) {
    const repeatRule = Object.assign({}, this.state.repeatRule, {recurrence})
    this.setState({repeatRule: repeatRule})
  }
  setRepeatStartDate (val) {
    let date = val && val.toISOString()
    let recurrence = this.state.repeatRule.recurrence || defaultRecurrence(date)
    if (val) {
      recurrence = Object.assign({}, recurrence, {
        day_of_month: recurrence.day_of_month || val.getDate(),
        weekday: recurrence.weekday != null ? recurrence.weekday : val.getDay()
      })
    }
    const repeatRule = Object.assign({}, this.state.repeatRule, {date: date, recurrence: recurrence})
    this.setState({repeatRule: repeatRule})
  }
  handleConfirm () {
    this.props.onRemove(this.props.editingIssue.id)
    this.setState({openConfirm: false})
    this.props.cancelEdit()
  }
  onAttachmentChange (e) {
    var attachmentNode = ReactDOM.findDOMNode(this.refs.attachment)
    var file = attachmentNode.files[0]
    if (file !== undefined) {
      this.uploadFile()
    }
  }
  uploadFile (e) {
    var attachmentNode = ReactDOM.findDOMNode(this.refs.attachment)
    var file = attachmentNode.files[0]
    // this.props.uploadFile(file, () => {
    //   ReactDOM.findDOMNode(this.refs.attachment).value = ''
    //   this.setState({
    //     enableFileUpload: false
    //   })
    // })
    const api = createAPIClient()
    const extension = file.name.split('.')[1]
    const fileName = file.name.split('.')[0].replace(/ /g, '') + '_' + (new Date()).getTime() + '.' + extension
    const _this = this
    _this.setState({
      imageUploading: true
    })
    api.get(`/api/private/upload/url-files?filename=${fileName}&type=incident-attachment`)
      .then(result => {
        const url = result.data.response
        const awsClient = createAWSClient()
        awsClient.put(url, file, {})
          .then(() => {
            var saveUrl = url.split('?')[0]
            var attachments = []
            attachments = attachments.concat(this.state.newIssue.attachments)
            attachments.push({url: saveUrl, key: saveUrl})
            const updateNewIssue = Object.assign({}, _this.state.newIssue, {attachments: attachments})
            _this.setState({newIssue: updateNewIssue})
            _this.setState({
              imageUploading: false
            })
            // changeUploadingState.bind(this)(false)
            // successCallback()
          })
          .catch(error => {
            console.log(error)
            _this.setState({
              imageUploading: false
            })
            // changeUploadingState.bind(this)(false)
          })
      })
      .catch(error => {
        console.log(error)
        _this.setState({
          imageUploading: false
        })
        // changeUploadingState.bind(this)(false)
      })
  }
  removeAttachment (id, key) {
    // this.props.removeAttachment(id, key)
    const attachments = []
    if (id !== undefined) {
      for (let i = 0; i < this.state.newIssue.attachments.length; i++) {
        if (this.state.newIssue.attachments[i]._id !== id) {
          attachments.push(this.state.newIssue.attachments[i])
        }
      }
    } else {
      for (let i = 0; i < this.state.newIssue.attachments.length; i++) {
        if (this.state.newIssue.attachments[i].key !== key) {
          attachments.push(this.state.newIssue.attachments[i])
        }
      }
    }
    const updatedEditingIssue = Object.assign({}, this.state.newIssue, {
      attachments: attachments
    })
    this.setState({newIssue: updatedEditingIssue})
  }
  onSelectChange (id, e, {value}) {
    this.onInputChange({target: {name: id, value: value}})
  }
  onSelectChangeEditable (id, e) {
    if (!e) return
    let value
    if (e.__isNew__) {
      // value = {new_label: true, value: e.value}
      value = e.value
    } else {
      value = e.value
    }
    this.onInputChange({target: {name: id, value: value}})
  }
  onDateChange (id, date) {
    this.onInputChange({target: {name: id, value: date && date.toISOString()}})
  }
  onLabelChange (e, {value}) {
    this.onInputChange({target: {name: 'label', value: value}})
  }
  onInputChange (e) {
    const targetName = e.target.name
    const targetValue = e.target.value
    if (targetName === 'title' || targetName === 'description' || targetName === 'label') {
      const updatedEditingIssue = Object.assign({}, this.state.newIssue, {
        [targetName]: targetValue ? targetValue : null
      })
      this.setState({
        newIssue: updatedEditingIssue
      })
    } else {
      const updatedEditingIssue = Object.assign({}, this.state.newIssue)
      updatedEditingIssue.custom_field_values[targetName] = {value: targetValue, custom_field: targetName}
      this.setState({
        newIssue: updatedEditingIssue
      })
    }
  }
  onSubmitRepeatRule (issue) {
    const api = createAPIClient()
    const recurrence = Object.assign({}, this.state.repeatRule.recurrence, {
      anchor: this.state.repeatRule.date
    })
    const data = {
      name: this.state.repeatRule.name,
      next_run: this.state.repeatRule.date,
      location: this.props.location,
      template: this.props.currentTemplateId,
      recurrence: recurrence,
      issue: issue
    }
    api.post('/api/repeatrule', data)
      .then(result => {
        this.cancel()
      })
      .catch(err => {
        this.setState({editingError: true, editingErrorMessage: "Repeat rule submission failed."})
      })
  }
  onSubmitNewIssue (e) {
    const submitEdit = {
      title: this.state.newIssue.title,
      description: this.state.newIssue.description,
      label: this.state.newIssue.label,
      custom_field_values: [],
      attachments: [],
      location: this.props.location,
      template: this.props.currentTemplateId
    }
    for (let key in this.state.newIssue.custom_field_values) {
      var obj = this.state.newIssue.custom_field_values[key]
      if (obj.value) {
        delete obj['updated_at']
        delete obj['created_at']
        submitEdit.custom_field_values.push(obj)
      }
    }
    submitEdit.attachments = this.state.newIssue.attachments

    if (this.state.isRepeatRule) {
      this.onSubmitRepeatRule(submitEdit)
    } else {
      this.props.createIssueAction(submitEdit, (result, message) => {
        if (result) {
          this.cancel()
        } else {
          this.setState({editingError: true, editingErrorMessage: message})
        }
      })
    }
  }
  cancel () {
    this.setState({
      imageUploading: false,
      editingError: undefined,
      isRepeatRule: false,
      repeatRule: {
        name: '',
        date: undefined,
        recurrence: defaultRecurrence()
      },
      newIssue: {
        id: '',
        title: '',
        description: '',
        custom_field_values: {},
        attachments: []
      }
    })
    this.props.cancelNewIssue()
  }
  render () {
    var currentTemplate = this.props.templates.filter((temp) => {
      return temp.id === this.props.templateId
    })[0]
    var teamMemberOptions = currentTemplate && currentTemplate.all_users.map(teamMember => {
      return {key: teamMember.id, value: teamMember.id, text: teamMember.first_name +' '+teamMember.last_name}
    })
    const uploadButton = (
      <Label
        as='label'
        basic
        htmlFor='attachment'
      >
        <Button
          icon='upload'
          label={{
            basic: true,
            content: 'Attach file(s)'
          }}
          labelPosition='right'
          loading={this.state.imageUploading}
        />
        <input
          hidden
          id='attachment'
          name='attachment'
          onChange={this.onAttachmentChange.bind(this)}
          multiple
          type='file'
          ref='attachment'
        />
      </Label>

    )

    const editFormAttachmentList = (
      <Grid columns='5' divided>
        <Grid.Row>
          {this.state.newIssue.attachments.map((item, index) => {
            return (
              <Grid.Column key={item.key}>
                <Thumbnail src={item.url} url={item.url} />
                <a style={{color: 'red'}} href='#' onClick={this.removeAttachment.bind(this, item._id, item.key)}> <Icon name='close' /><u>Delete </u></a>
              </Grid.Column>
            )
          })}
        </Grid.Row>
      </Grid>
    )
    let labelOptions = this.props.labels.map(label => {
      return {
        key: label.id,
        text: label.name,
        value: label.id,
        label: { color: label.color, empty: true, circular: true }
      }
    })
    labelOptions.unshift({text: 'Select Label', value: undefined})
    const editForm = (
      <div>
        <Form id='editForm' onSubmit={this.onSubmitNewIssue.bind(this)}>
          {this.state.editingError ? (
            <Message negative>
              <Message.Header>{this.state.editingErrorMessage || 'Something went wrong'}</Message.Header>
            </Message>
          ) : undefined}

          {this.props.customFields.map(item => {
            return (
              <Field key={item.id}>
                <label>{item.name}{item.required ? '*' : ''}</label>
                {(() => {
                  switch (item.value_type) {
                    case 'Single select (API)':
                      return (
                        <Select placeholder='Select a value'
                                id='field_value_type' name='field_value_type'
                                options={[{key: 'empty', value: '', text: 'Select a value'}].concat(item.list_values.map(value => {
                                  return ({key: value, value: value, text: value})
                                }))
                                }
                                onChange={this.onSelectChange.bind(this, item.id)}
                        />
                      )
                    case 'Picklist':
                      return (
                        <CreatableSelect
                          isClearable
                          onChange={this.onSelectChangeEditable.bind(this, item.id)}
                          options={[{value: '', label: 'Select a value'}].concat(item.list_values.map(value => {
                            return ({value: value, label: value})
                          }))
                          }
                        />
                      )
                    case 'TeamMember':
                      return (
                        <Dropdown
                          fluid
                          selection
                          multiple
                          options={teamMemberOptions}
                          onChange={this.onSelectChange.bind(this, item.id)}

                        />
                      )
                    case 'Calendar':
                      return (
                        <DatePicker
                          selected={this.state.newIssue.custom_field_values[item.id] && moment(this.state.newIssue.custom_field_values[item.id].value).toDate()}
                          onChange={this.onDateChange.bind(this, item.id)}
                          showTimeInput
                          dateFormat="dd/MM/yyyy h:mm aa"
                        />
                      )
                    default:
                      return (
                        <TextArea rows={1} autoHeight id={item.id} name={item.id} onChange={this.onInputChange.bind(this)}
                                  value={this.state.newIssue.custom_field_values[item.id] && this.state.newIssue.custom_field_values[item.id].value}
                                  required={item.required}
                        />
                      )
                  }
                })()}
              </Field>
            )
          })}
          <Field>
            <label>Label</label>
            <Dropdown placeholder='Select Label' fluid selection options={labelOptions} onChange={this.onLabelChange.bind(this)} />
          </Field>
          <h5>Attachment list</h5>
          {editFormAttachmentList}
          <br />
          {uploadButton}
        </Form>
      </div>
    )
    let repeatOptions = [
      {key: 'weekly', text: 'Weekly', value: 'weekly'},
      {key: 'fortnightly', text: 'Fortnightly', value: 'fortnightly'},
      {key: 'monthly', text: 'Monthly', value: 'monthly'},
      {key: '6months', text: 'Every six month', value: '6months'},
      {key: 'yearly', text: 'Yearly', value: 'yearly'}
    ]
    const cronRule = (
      <div>
        <Form>
          <Field>
            <label>{'Rule name*'}</label>
            <TextArea rows={1} autoHeight required onChange={this.setRepeatRuleName.bind(this)}/>
          </Field>
          <Field>
            <label>Start date</label>
            <DatePicker
              style={{width:'100%'}}
              selected={this.state.repeatRule.date && moment(this.state.repeatRule.date).toDate()}
              showTimeSelect
              timeIntervals={60}
              dateFormat="dd/MM/yyyy h:mm aa"
              onChange={this.setRepeatStartDate.bind(this)}
            />
          </Field>
          {this.state.repeatRule.date ? (
            <RecurrencePicker
              value={this.state.repeatRule.recurrence}
              startDate={this.state.repeatRule.date}
              onChange={this.setRecurrence.bind(this)}
            />
          ) : (
            <Message info content='Select a start date to configure the repeat schedule.' />
          )}
        </Form>
      </div>
    )
    const repeatRuleComponent = (
      <div>
        <Checkbox label='Make this a repeating issue template.' value={this.state.isRepeatRule} onChange={this.switchRepeatRule.bind(this)} />
        {this.state.isRepeatRule ? cronRule: null}
      </div>
    )
    const modal = (
      <Modal open={this.props.openNewIssue} style={modalStyle} onClose={this.cancel.bind(this)}>
        <Modal.Header style={{overflow: 'hidden'}}>
          Record
          <a href='#'>
            <Image onClick={this.cancel.bind(this)} style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px'}} avatar src={'/icons/close_432859.svg'} />
          </a>
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            {editForm}
            <br/>
            {repeatRuleComponent}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button primary icon='check' content='Add' type='submit' form='editForm' />
        </Modal.Actions>
      </Modal>
    )
    return modal
  }
}

function mapStateToProps (state) {
  return {location: state.account.user.locations[0], templates: state.templates.templates}
}

export default connect(mapStateToProps, {
  createIssueAction
})(EditForm)



// WEBPACK FOOTER //
// ./src/pages/issues/overview/components/new/index.js